var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTree = function SvgTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M6.107 21.752h-.393L10.6 11.96l.722-1.447h-1.234l5.163-8.574 5.164 8.575h-1.294l.797 1.475 5.274 9.763h-1.926l.693 1.435 5.413 11.203h-12.21v2.654H13.47V34.39H1.594l5.413-11.203.693-1.435z"
  })));
};
export default SvgTree;